import React, { Suspense, useEffect, useState} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from "./pages/Home"
import Upload from "./pages/Upload"
import Update from './pages/Update';
import Drivers from "./pages/Drivers";
import BackSeat from "./pages/BackSeat";
import Booking from "./pages/Booking";
import { allApps } from './Components/appTypes';
import { appSearch } from './Components/appDetail';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Stack, Typography } from '@mui/material';
import './App.css';
import './pages/appPages/appPage.css';

function GradientCircularProgress() {
  return (
    <Box sx={{ position: 'relative', justifyContent: 'center', width: '200px', height: '200px', margin: 'auto'}}>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#f4a211" />
            <stop offset="100%" stopColor="#050A44" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress 
    
      sx={{ 'svg circle': { stroke: 'url(#my_gradient)' }, animationDuration: '2500ms'}}  
      size={200}/>
       <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.secondary' }}
        >
          {`Loading...`}
        </Typography>
      </Box>
      </Box>
  );
}


const App = () => {
  const [comps, setComps] = useState({})
  const [isLoading, setIsLoading] = useState(true)


  useEffect(() => {
    async function fetchApps() {
      const APILinksFetch = await fetch('/APILinks.json')
      const APILinks = await APILinksFetch.json()
      const res = await fetch(APILinks['getAppList'])
      const data = await res.json()
      setComps(data)
      setIsLoading(false)

      setTimeout(() => {
        fetchApps();
      }, 1800000)
    }      
    
    fetchApps();
    
   
  }, [])
  return isLoading ? 
  ( <Stack className="stack" alignItems="center" sx={{width: '100%', height: '100%'}}> 
      <GradientCircularProgress />
    </Stack>)
   : 
   (React.createElement('div', { className: 'App' },
    React.createElement(Router, null,
      React.createElement(Suspense, { fallback: React.createElement('div', null, 'Loading...') },
        React.createElement(Routes, null,
          React.createElement(Route, { path: '/', element: React.createElement(HomePage, comps) }),
          React.createElement(Route, { path: '/Upload', element: React.createElement(Upload, {comps: comps}) }),
          React.createElement(Route, { path: '/Update', element: React.createElement(Update, {comps: comps, setComps: setComps}) }),
          React.createElement(Route, { path: '/Driver', element: React.createElement(Drivers, comps) }),
          React.createElement(Route, { path: '/BackSeat', element: React.createElement(BackSeat, comps) }),
          React.createElement(Route, { path: '/Booking', element: React.createElement(Booking, comps) }),
          // The detail view is now a modal on the grid pages, keyed by `?app=`.
          // These per-app routes stay registered so links shared before the
          // redesign still land on the right app — they just redirect to it.
          allApps(comps).map((company) => {
            return React.createElement(Route, {
              key: company.key,
              path: company.navLink,
              element: React.createElement(Navigate, {
                to: { pathname: '/', search: appSearch(company.navLink) },
                replace: true
              })
            });
          }),
        )
      )
    )
  ));

};

export default App;